export default snapshot => snapshot.docs.map(doc => ({
    ...doc.data(),
    id: doc.id
}));
